function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { rgba } from "polished";
export default (function (theme) {
  function addStates(css, _ref) {
    var hover = _ref.hover,
        active = _ref.active,
        loading = _ref.loading,
        showLoadingIcon = _ref.showLoadingIcon,
        disabled = _ref.disabled,
        __internal__hover = _ref.__internal__hover,
        __internal__active = _ref.__internal__active;

    if (showLoadingIcon) {
      return _objectSpread(_objectSpread({}, css), loading);
    }

    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, css), {}, {
      ":hover:not(:disabled)": hover
    }, __internal__hover && hover), {}, {
      ":active:not(:disabled)": active
    }, __internal__active && active), disabled && {
      ":disabled": _objectSpread(_objectSpread({}, css[":disabled"]), disabled)
    });
  }

  return {
    getCSS: function getCSS(_ref2) {
      var targetElement = _ref2.targetElement,
          variant = _ref2.variant,
          color = _ref2.color,
          showLoadingIcon = _ref2.showLoadingIcon,
          __internal__keyboardFocus = _ref2.__internal__keyboardFocus,
          __internal__hover = _ref2.__internal__hover,
          __internal__active = _ref2.__internal__active;

      switch (targetElement) {
        case "button":
          {
            var css = _objectSpread(_objectSpread(_objectSpread({
              position: "relative",
              fontSize: theme.fontSizes[2],
              lineHeight: theme.lineHeights[3],
              fontFamily: theme.fonts.body,
              fontWeight: theme.fontWeights.medium,
              margin: 0,
              border: 0,
              padding: "0 ".concat(theme.space[6]),
              minHeight: "48px",
              overflow: "hidden",
              transition: theme.transitions.button,
              borderRadius: theme.radii[1],
              outline: 0
            }, theme.focusStyles.focusVisible), __internal__keyboardFocus && theme.focusStyles.__keyboardFocus), !showLoadingIcon && {
              ":disabled": {
                backgroundColor: theme.colors.grey.t30,
                color: theme.colors.grey.t75,
                opacity: 0.7,
                cursor: "not-allowed"
              }
            });

            switch (true) {
              case variant === "primary" && color === "highlight.blue.t100":
                {
                  css = addStates(_objectSpread(_objectSpread({}, css), {}, {
                    backgroundColor: theme.colors.highlight.blue.t100,
                    color: theme.colors.white
                  }), {
                    hover: {
                      backgroundColor: theme.colors.primary.blue.t100,
                      color: theme.colors.white
                    },
                    active: {
                      backgroundColor: theme.colors.primary.blue.t100,
                      color: theme.colors.white
                    },
                    loading: {
                      backgroundColor: "transparent",
                      borderWidth: theme.borderWidths[0],
                      borderStyle: "solid",
                      borderColor: rgba(theme.colors.black, 0.35),
                      cursor: "progress"
                    },
                    showLoadingIcon: showLoadingIcon,
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  });
                  break;
                }

              case variant === "primary" && color === "white":
                {
                  css = addStates(_objectSpread(_objectSpread({}, css), {}, {
                    backgroundColor: theme.colors.white,
                    color: theme.colors.highlight.blue.t100
                  }), {
                    hover: {
                      backgroundColor: theme.colors.secondary.lightBlue.t25,
                      color: theme.colors.primary.blue.t100
                    },
                    active: {
                      backgroundColor: theme.colors.secondary.lightBlue.t25,
                      color: theme.colors.primary.blue.t100
                    },
                    loading: {
                      backgroundColor: "transparent",
                      borderWidth: theme.borderWidths[0],
                      borderStyle: "solid",
                      borderColor: rgba(theme.colors.white, 0.35),
                      cursor: "progress"
                    },
                    showLoadingIcon: showLoadingIcon,
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  });
                  break;
                }

              case variant === "primary" && color === "green":
                {
                  css = addStates(_objectSpread(_objectSpread({}, css), {}, {
                    backgroundColor: "#21a637",
                    color: theme.colors.white
                  }), {
                    hover: {
                      backgroundColor: "#007414",
                      color: theme.colors.white
                    },
                    active: {
                      backgroundColor: "#007414",
                      color: theme.colors.white
                    },
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  });
                  break;
                }

              case variant === "secondary" && color === "highlight.blue.t100":
                {
                  css = addStates(_objectSpread(_objectSpread({}, css), {}, {
                    backgroundColor: "transparent",
                    color: theme.colors.highlight.blue.t100,
                    borderWidth: theme.borderWidths[0],
                    borderStyle: "solid",
                    borderColor: theme.colors.highlight.blue.t100
                  }), {
                    hover: {
                      backgroundColor: theme.colors.highlight.blue.t100,
                      color: theme.colors.white
                    },
                    active: {
                      backgroundColor: theme.colors.highlight.blue.t100,
                      color: theme.colors.white
                    },
                    loading: {
                      backgroundColor: "transparent",
                      borderWidth: theme.borderWidths[0],
                      borderStyle: "solid",
                      borderColor: rgba(theme.colors.black, 0.35),
                      cursor: "progress"
                    },
                    showLoadingIcon: showLoadingIcon,
                    disabled: {
                      borderColor: theme.colors.grey.t65
                    },
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  });
                  break;
                }

              case variant === "secondary" && color === "black":
                {
                  css = addStates(_objectSpread(_objectSpread({}, css), {}, {
                    backgroundColor: "transparent",
                    color: theme.colors.black,
                    borderWidth: theme.borderWidths[0],
                    borderStyle: "solid",
                    borderColor: theme.colors.black
                  }), {
                    hover: {
                      backgroundColor: theme.colors.highlight.blue.t100,
                      color: theme.colors.white,
                      borderColor: theme.colors.highlight.blue.t100
                    },
                    active: {
                      backgroundColor: theme.colors.highlight.blue.t100,
                      color: theme.colors.white,
                      borderColor: theme.colors.highlight.blue.t100
                    },
                    loading: {
                      backgroundColor: "transparent",
                      borderWidth: theme.borderWidths[0],
                      borderStyle: "solid",
                      borderColor: rgba(theme.colors.black, 0.35),
                      cursor: "progress"
                    },
                    showLoadingIcon: showLoadingIcon,
                    disabled: {
                      borderColor: theme.colors.grey.t65
                    },
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  });
                  break;
                }

              case variant === "secondary" && color === "white":
                {
                  css = addStates(_objectSpread(_objectSpread({}, css), {}, {
                    backgroundColor: "transparent",
                    color: theme.colors.white,
                    borderWidth: theme.borderWidths[0],
                    borderStyle: "solid",
                    borderColor: theme.colors.white
                  }), {
                    hover: {
                      backgroundColor: theme.colors.white,
                      color: theme.colors.highlight.blue.t100
                    },
                    active: {
                      backgroundColor: theme.colors.white,
                      color: theme.colors.highlight.blue.t100
                    },
                    loading: {
                      backgroundColor: "transparent",
                      borderWidth: theme.borderWidths[0],
                      borderStyle: "solid",
                      borderColor: rgba(theme.colors.white, 0.35),
                      cursor: "progress"
                    },
                    showLoadingIcon: showLoadingIcon,
                    disabled: {
                      backgroundColor: theme.colors.grey.t30
                    },
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  });
                  break;
                }

              case variant === "icon":
                {
                  css = addStates(_objectSpread(_objectSpread({}, css), {}, {
                    display: "flex",
                    alignItems: "center",
                    padding: "0 ".concat(theme.space[2]),
                    backgroundColor: "transparent"
                  }), {
                    hover: {
                      backgroundColor: theme.colors.grey.t10
                    },
                    active: {
                      backgroundColor: theme.colors.grey.t10
                    },
                    __internal__hover: __internal__hover,
                    __internal__active: __internal__active
                  });
                  break;
                }

              default:
                {
                  break;
                }
            }

            return css;
          }

        case "loadingIcon":
          {
            return {
              position: "absolute",
              top: "calc(50% - 10px)",
              left: "calc(50% - 10px)"
            };
          }

        case "content":
          {
            if (showLoadingIcon) {
              return {
                opacity: 0
              };
            }

            return {};
          }

        default:
          {
            return {};
          }
      }
    }
  };
});